import type { FlowScreenConfig } from "@/shared/constants/flowTypes";
import { EmploymentForm, validateEmployers } from "../components/EmploymentForm";
import { createModuleComplete } from "@/pages/postloss/modules/components/ModuleComplete";

export function createEmploymentScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "employment_info",
      textAlign: "center",
      layout: "full",
      maxWidth: "2xl",
      title: "Employment information",
      subtitle:
        "Employer benefits can include pensions, retirement accounts, and life insurance worth thousands of dollars.",
      hideButton: true,
      customComponent: EmploymentForm,
      validate: validateEmployers,
    },
    {
      id: "union_membership",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Was ${firstName} ever in a union?`,
      subtitle:
        "Union members may be eligible for survivor benefits, death benefits, and pension programs.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          {
            value: "yes",
            label: "Yes, they were in a union",
            hasTextInput: true,
            textInputPlaceholder: "Enter union name (optional)",
          },
          { value: "no", label: "No" },
          { value: "not_sure", label: "I'm not sure" },
        ],
      },
    },
    {
      id: "pension_status",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} ever have a pension?`,
      subtitle: "Pensions may include survivor benefits or ongoing payments to beneficiaries.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they had a pension" },
          { value: "no", label: "No" },
          { value: "not_sure", label: "I'm not sure" },
        ],
      },
    },
    {
      id: "final_screen",
      layout: "full",
      textAlign: "center",
      hideButton: true,
      headerTitle: "",
      customComponent: createModuleComplete(),
    },
  ];
}
